import type { ImgHTMLAttributes } from "react";

type ClickableQrCodeProps = {
  src: string;
  /** Encoded target URL; when set, the QR image opens this link. */
  href?: string | null;
  alt?: string;
} & Omit<ImgHTMLAttributes<HTMLImageElement>, "src" | "alt">;

/** QR image that opens the encoded URL when clicked. */
export function ClickableQrCode({
  src,
  href,
  alt = "QR-Code",
  className,
  ...imgProps
}: ClickableQrCodeProps) {
  const img = <img src={src} alt={alt} className={className} {...imgProps} />;

  if (!href) return img;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      title="Verknüpften Link öffnen"
      className="inline-block cursor-pointer transition-opacity hover:opacity-90"
    >
      {img}
    </a>
  );
}
